import { APP_INITIALIZER, ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { UserService } from './providers/user/user.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { AuthGuard } from './guards/auth-guard/auth.guard';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorsHandler } from './errors/errors.handle';
import { Driver, NgForage, NgForageConfig } from 'ngforage';
import { NgxHttpClient, NgxHttpClientAuthTypeToken, NgxHttpClientExtraOptions, NgxHttpClientModule } from 'ngx-httpclient';
import { NavigatorsCheckGuard } from './guards/navigators-check-guard/navigators-check.guard';
import { Angulartics2Module } from 'angulartics2';
import { HttpErrorInterceptor } from './errors/http.error.interceptor';
import { GlobalErrorHandler } from './errors/error.handle';

import { CommonService } from './providers/forms/common.service';
import { AuthService } from './providers/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NGXLogger, NGXLoggerHttpService, NGXMapperService } from 'ngx-logger';

/**
 * ngxHttpClientCreator
 * @param http http
 * @param ngf ngf
 * @returns returns
 */
export const ngxHttpClientCreator: (http: HttpClient, ngf: NgForage) => NgxHttpClient =
(http: HttpClient, ngf: NgForage): NgxHttpClient => {
  const extraOptions: NgxHttpClientExtraOptions = {
    authorization: {
      localStorageTokenName: `X-Token`,
      type: NgxHttpClientAuthTypeToken.Bearer,
      nameHeader: 'Authorization',
      storage: ngf
    }
  };

  return new NgxHttpClient(http, extraOptions);
};

/**
 * @description HttpLoaderFactory
 * @param http http
 * @returns returns
 */
export const HttpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient): TranslateHttpLoader => {
  return new TranslateHttpLoader(http);
};
/**
 * @description setupTranslateFactory
 * @param service service
 * @returns returns
 */
export const setupTranslateFactory: (service: TranslateService) => () => Observable<any> =
(service: TranslateService): () => Observable<any> => {
  // return () => service.use('es');

  // TODO: realizar el set en la web
  // localStorage.removeItem('language');
  // localStorage.setItem('language', 'es');
  // TODO: realizar el set en la web - FIN
   let languageSelected = '';
   const languageSelectedAux: string = localStorage.getItem('language');
   if (languageSelectedAux !== '' && languageSelectedAux !== null) {
    languageSelected = languageSelectedAux;
  } else { languageSelected = 'es'; }
   return () => service.use(languageSelected);
};

const SERVICES: any[] = [
  {
    provide: APP_INITIALIZER,
    useFactory: setupTranslateFactory,
    deps: [TranslateService],
    multi: true
  },
  CommonService,
  UserService,
  AuthService,
  ErrorsHandler,
  NGXLogger,
  NGXMapperService,
  NGXLoggerHttpService,
  {
    provide: ErrorHandler,
    useClass: ErrorsHandler
  }
];

const GUARDS: any[] = [
  AuthGuard,
  NavigatorsCheckGuard
];

@NgModule({
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    NgxHttpClientModule.forRoot({
      loader: {
        provide: NgxHttpClient,
        useFactory: ngxHttpClientCreator,
        deps: [HttpClient, NgForage]
      }
    }),
    Angulartics2Module.forRoot()
  ],
  providers: [...SERVICES, ...GUARDS,
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
})
export class CoreModule {
  /**
   * @description constructor
   * @params parentModule
   * @params ngfConfig
   */
  constructor(@Optional() @SkipSelf() parentModule: CoreModule,
              ngfConfig: NgForageConfig,
              private activatedRoute: ActivatedRoute,
              public service: TranslateService
  ) {
    this.activatedRoute = activatedRoute;
    this.service = service;

    if (parentModule) {
      throw new Error('CoreModule has already been loaded. You should only import Core modules in the AppModule only.');
    }
    this.activatedRoute.queryParams.subscribe((params: any) => {
      let langParam = 'es';
      if (params.lang !== undefined) {
        langParam = params.lang;
      } else {
        langParam = 'es';
      }
      this.setLangForm(langParam);
    });
    ngfConfig.configure({
      name: 'funil-pwa',
      driver: [
        Driver.LOCAL_STORAGE
      ]
    });
  }

  /**
   * setLangForm
   * @param paramLang paramLang
   */
  setLangForm(paramLang: string): void {
    this.service.use(paramLang);
  }
}
